import NoMunicipalityRoutes from 'js/vue-plugins/vue-router/routes/no-municipality' // OK
import CustomNoMunicipalityRoutes from 'js/vue-plugins/vue-router/routes/custom-no-municipality' // OK
import MunicipalityRoutes from 'js/vue-plugins/vue-router/routes/municipalities/index' // OK
import PrivacyPolicyRoutes from 'js/vue-plugins/vue-router/routes/privacy-policy' // OK
import SystemRoutes from 'js/vue-plugins/vue-router/routes/system' // OK 
import LearnMoreRoutes from 'js/vue-plugins/vue-router/routes/learn-more' // OK
import InfoCards from 'js/vue-plugins/vue-router/routes/info-cards' // OK

const routes = [
  ...normalizeRoutes(MunicipalityRoutes),
  ...normalizeRoutes(NoMunicipalityRoutes),
  ...normalizeRoutes(CustomNoMunicipalityRoutes),
  ...normalizeRoutes(PrivacyPolicyRoutes),
  ...normalizeRoutes(SystemRoutes),
  ...normalizeRoutes(LearnMoreRoutes),
  ...normalizeRoutes(InfoCards)
]

// devDump("DEFINED ROUTES", routes)

export default routes
